/** @format */
import allLogs from "./dustLogs/index";

const DUST_SERVICE_HOST = {
  // DEV: 'https://librec-paper-data-collect.vercel.app/',
  // PROD: 'https://librec-paper-data-collect.vercel.app/',
  DEV: "http://1.14.62.248/:7000/",
  PROD: "http://1.14.62.248/:7000/",
};

const API_PATH = {
  json: {
    // DEV: 'api/event/json',
    DEV: "/collect/event",
    PROD: "/collect/event",
  },
  list: {
    DEV: "api/event/list",
    PROD: "api/event/list",
  },
};

const dustLogServiceUrl =
  process.env.NODE_ENV === "development"
    ? DUST_SERVICE_HOST.DEV
    : DUST_SERVICE_HOST.PROD;

const apiPath =
  process.env.NODE_ENV === "development"
    ? API_PATH.json.DEV
    : API_PATH.json.PROD;

const dustConfig = {
  dustLogServiceUrl,
  apiPath,
  globalConfig: {
    app_id: 8104,
    app_name: "LibRec Paper",
    headers: {
      x_dust_log_id: "123456",
    },
  },
  // 默认公参
  defaultCommonParams: {
    app_id: 8104,
    fe_flag: "React",
    userId: "",
    username: "",
  },
  logs: {
    ...allLogs,
    lsk: {
      event: "lsk_emit",
      params: {
        page: "lsk",
      },
    },
    // 前端性能数据埋点
    webPerformanceLog: {
      url: "/api/performance/index",
      event: "web_performance",
      params: {
        page: "app",
      },
    },
  },
};

export default dustConfig;
